module.exports = __webpack_public_path__ + "static/media/misc.cca45ff5.svg";